import { Therapist } from '../interfaces';
import { getDashboardRole } from '../DashboardAccess';

// Legacy members without an explicit status are active; pending and suspended accounts cannot own billing.
export function getEligibleBillingOwnerCandidates(therapists: Therapist[]): Therapist[] {
    return therapists.filter((therapist) =>
        getDashboardRole(therapist) === 'admin' &&
        therapist.billingRole !== 'owner' &&
        (!therapist.membershipStatus || therapist.membershipStatus === 'active')
    );
}
